<div class="addEvent" [formGroup]="acceptEventFG">
  <h1 mat-dialog-title>Aceptar meta</h1>
  <mat-form-field class="">
    <mat-label>Comentario adicional *</mat-label>
    <textarea matInput formControlName="comment"></textarea>
  </mat-form-field>
  <button mat-stroked-button class="btn-blue" (click)="close()">Meta realizada</button>
  <img src="assets/icons/close.svg" alt="" (click)="this.dialogRef.close(false)">
</div>
